import AppSplash from '@portal/features/feedback/AppSplash'
import ErrorState from '@portal/features/feedback/ErrorState'
import NotFoundPage from '@portal/features/feedback/NotFoundPage'
import { createRootRoute, Outlet } from '@tanstack/react-router'
import { useAuthStore, waitForAuthReady } from '@zealth/core/firebase/authStore'

const RootComponent = () => <Outlet />

const RootErrorComponent = ({ error }: { error: Error }) => (
  <ErrorState error={error} />
)

export const Route = createRootRoute({
  beforeLoad: async () => {
    await waitForAuthReady()
    const authError = useAuthStore.getState().error
    if (authError) {
      throw authError
    }
  },
  pendingComponent: AppSplash,
  errorComponent: RootErrorComponent,
  component: RootComponent,
  notFoundComponent: NotFoundPage,
})
